import * as LicensesApi from '@bmai/licenses-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new LicensesApi.Configuration(ApiClientFactory.createConfig('/_licenses'));

export const licensesClient = ApiClientFactory.instantiateApis(LicensesApi, configuration);
